import { supabase } from "../../lib/supabase";

interface Profile {
  id: string;
  first_name?: string;
  last_name?: string;
  timezone?: string;
  created_at?: string;
  updated_at?: string;
}

export async function createProfile(userId: string, firstName: string, lastName: string) {
  const { error } = await supabase
    .from("profiles")
    .insert({
      id: userId,
      first_name: firstName,
      last_name: lastName,
      updated_at: new Date().toISOString(),
    });

  if (error) throw error;
}

async function getProfile(userId: string) {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) {
    console.error('Error fetching profile:', error);
    throw error;
  }

  return data as Profile;
}

async function updateProfile(userId: string, updates: Partial<Profile>) {
  const { data, error } = await supabase
    .from('profiles')
    .update({
      ...updates,
      updated_at: new Date().toISOString()
    })
    .eq('id', userId)
    .select()
    .single();

  if (error) {
    console.error('Error updating profile:', error);
    throw error;
  }

  return data as Profile;
}

export const profilesService = {
  getProfile,
  updateProfile
};